/** Poll interval for live match badges and official score controls (ms). */
export const LIVE_MATCH_REFRESH_MS = 15_000;

/**
 * Run callback on an interval; returns a cleanup function for onUnmounted.
 * @param {() => void | Promise<void>} callback
 * @param {number} [intervalMs]
 */
export function startLiveRefresh(callback, intervalMs = LIVE_MATCH_REFRESH_MS) {
  const id = setInterval(() => {
    void callback();
  }, intervalMs);
  return () => clearInterval(id);
}
